export default __webpack_public_path__ + "static/team1_mobile-ce3e1cf5ac801d321901e81e32f27866.jpg";